import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Yii } from "../../../../../libraries/interfaces/Yii";
import { IFieldSpecs } from "../../../../../libraries/module/formbuilder/fields/interfaces/field-specs";
import { FormControl, FormGroup } from "@angular/forms";
import { Required } from "../../../../../libraries/module/formbuilder/forms/utils/validators/required.validator";
import { WatabilightService } from "../../../../service/watabilight.service";
import { ICustomerAgency } from "../../../../../libraries/interfaces/watabilight/IWatabiLightBooking.interface";
import {
  SimpleTextareaFieldComponent
} from "../../../../../libraries/module/formbuilder/fields/simple-textarea-field/simple-textarea-field.component";

export interface IMailDialogData {
  url: any;
  template: any;
  value: any;
}

class Wording {
  public readonly title : string = Yii.t('wui-shared-js', 'Envoyer la restitution par email');
  public readonly to : string = Yii.t('wui-shared-js', 'Destinataire');
  public readonly cc : string = Yii.t('wui-shared-js', 'Copie à');
  public readonly subject : string = Yii.t('wui-shared-js', 'Sujet');
  public readonly body : string = Yii.t('wui-shared-js', 'Message');
  public readonly send : string = Yii.t('wui-shared-js', 'Envoyer');
  public readonly cancel : string = Yii.t('wui-shared-js', 'Annuler');
}

interface IMailConfig {
  toConfig: IFieldSpecs;
  ccConfig: IFieldSpecs;
  subjectConfig: IFieldSpecs;
  bodyConfig: IFieldSpecs;
}

export interface IMailValue {
  from: string;
  to: string;
  cc: string;
  bcc: string;
  replyTo: string;
  subject: string;
  body: string;
}

enum EFormControlName {
  from = "from",
  to = "to",
  cc = "cc",
  replyTo = "replyTo",
  subject = "subject",
  body = "body",
}

@Component({
  selector: 'mail.dialog',
  templateUrl: "./mail-dialog.component.html",
  styles: [`
    .content {
      padding: 10px;
    }
    
    .mat-dialog-content {
      overflow: unset;
    }
    
    .mail {
      width: 100%;
      height: fit-content;
    }
    
    .mailBody {
      padding: 5px;
      border: 1px solid #e6eaed;
      cursor: initial;
    }
  `]
})
export class MailDialogComponent implements OnInit {
  @ViewChild("bodyMail")
  public bodyMail: SimpleTextareaFieldComponent;

  public wording: Wording = new Wording();
  public mailData: IMailValue;
  public mailConfig: IMailConfig;
  public form: FormGroup;

  constructor(
      public dialogRef: MatDialogRef<MailDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: IMailDialogData,
      private watabilightService: WatabilightService,
      private readonly cdr: ChangeDetectorRef
  ) {
    dialogRef.disableClose = true;
  }

  public ngOnInit(): void {
    this.initFormControl();
    this.initFormFieldConfig();
    this.setValue();
  }

  public onNoClick(): void {
    // this.dialogRef.close();
  }

  public initFormControl(): void {
    this.form = new FormGroup({});
    this.form.setControl(EFormControlName.to, new FormControl());
    this.form.setControl(EFormControlName.cc, new FormControl());
    this.form.setControl(EFormControlName.subject, new FormControl());
    this.form.setControl(EFormControlName.body, new FormControl());
    this.form.setControl(EFormControlName.from, new FormControl());
    this.form.setControl(EFormControlName.replyTo, new FormControl());
  }

  public initFormFieldConfig(): void {
    this.mailConfig = {
      toConfig: this.getFieldConfig(EFormControlName.to ,true),
      ccConfig: this.getFieldConfig(EFormControlName.cc),
      subjectConfig: this.getFieldConfig(EFormControlName.subject),
      bodyConfig: this.getFieldConfig(EFormControlName.body)
    };
  }

  public editMail(event: any): void {
    this.form.get(EFormControlName.body)?.patchValue(event.srcElement.innerHTML);
  }

  public setValue(): void {
    this.patchValueIfExist(this.replaceValue(this.data.template.replyTo), EFormControlName.from);
    this.patchValueIfExist(this.replaceValue(this.data.template.to), EFormControlName.to);
    this.patchValueIfExist("", EFormControlName.cc);
    this.patchValueIfExist(this.replaceValue(this.data.template.replyTo), EFormControlName.replyTo);
    this.patchValueIfExist(this.replaceValue(this.data.template.subject), EFormControlName.subject);
    this.patchValueIfExist(this.fillBody(), EFormControlName.body);
    this.mailData = this.form.value;
  }

  public patchValueIfExist(val: string, formControlName: string): void {
    if (val) {
      this.form.get(formControlName).patchValue(val);
    }
    else {
      this.form.get(formControlName).patchValue("");
    }
  }

  public fillBody(): string {
    const message: any = this.data.template.message;
    console.log(message);
    let val: string = this.replaceValue(message.header);
    val = `${val}<br/>`;
    if (this.data.url.html) {
      val = `${val}<a id='htmlLink' href=${this.data.url.html} target="_blank">${message.body.html.label}</a><br/>`;
    }
    if (this.data.url.pdf) {
      val = `${val}<a id='pdfLink' href=${this.data.url.pdf} target="_blank">${message.body.pdf.label}</a></br>`;
    }
    val = val + this.replaceValue(message.footer);
    return val;
  }

  public replaceValue(msg: string): string {
    let val: string = msg;
    if (val) {
      if (this.data.value?.customer) {
        const custumerData: any = this.data.value.customer;
        if (val.includes("$customerName")) {
          const title: string = custumerData.title;
          const firstName: string = custumerData.firstName;
          const lastName: string = custumerData.lastName;
          const customer: string = `${title} ${firstName} ${lastName}`;
          val = val.replace("$customerName", customer);
        }

        if (val.includes("$customerSimpleName")) {
          const title: string = custumerData.title;
          const lastName: string = custumerData.lastName;
          const customer: string = `${title} ${lastName}`;
          val = val.replace("$customerName", customer);
        }
        if (val.includes("$customerMail")) {
          const mail: string = custumerData.email;
          val = val.replace("$customerMail", mail);
        }
        if (val.includes("$bookingIds")) {
          val.replace("$bookingIds", `${this.data.value?.idItem}/${this.data.value?.idVersion}`);
        }
      }

      if (val.includes("$reference")) {
        const reference: any[] = this.data.value.externalReferences;
        let refMsg: string = "";
        reference?.forEach((refItem: any) => {
          const code: string = refItem.firstName;
          const value: string = refItem.lastName;
          refMsg = `${refMsg} ${code} ${value}`;
        });
        val = val.replace("$reference", refMsg);
      }

      if (val.includes("$title")) {
        const introduction: any[] = this.data.value.descriptions;
        let title: string = "";
        if (introduction.length > 0) {
          title = introduction[0].title;
        }
        val = val.replace("$title", title);
      }

      if (val.includes("$begin")) {
        const begin: string = this.data.value.begin;
        val = val.replace("$begin", begin);
      }

      if (val.includes("$agencyName")) {
        const name: string = this.getAgValStr(this.data.value,["name", "value"]);
        val = val.replace("$agencyName", name);
      }

      if (val.includes("$agencyMail")) {
        const mail: string = this.getFirstOrNull(this.getAgValStrArr(this.data.value,["emailArray"]), "text");
        val = val.replace("$agencyMail", mail);
      }
    }
    return (val);
  }

  public editMailEvent(): void {
    // console.log(this.form.value);
    this.mailData = this.form.value;
  }

  public send(): void {
    this.watabilightService.sendFinalMail(this.form.value).subscribe({
      next: (value: any) => {
        this.watabilightService.switchXToken();
        this.dialogRef.close();
      },
      error: (error: any) => {
        this.watabilightService.switchXToken();
        this.dialogRef.close(error);
      }
    });
  }

  public cancel(): void {
    this.dialogRef.close();
  }

  private getFieldConfig(formControlName: string, required: boolean = false): IFieldSpecs {
    return {
      formGroup: this.form,
      formControlName,
      label: this.wording[formControlName],
      validators: (required ? [new Required()] : []),
      withAsteriskIfRequired: true
    };
  }

  private getFirstOrNull(phoneArray: any, key: string): string {
    if (phoneArray && phoneArray.length) {
      return phoneArray[0][key];
    }
    return null;
  }

  private find(data: any, key: string[]): any | any[] {
    if (!data)
      return null;
    const editKey: string[] = Object.assign([], key);
    if (editKey.length === 1 && data[editKey[0]]) {
      return (data[editKey[0]]);
    }
    else if (editKey.length > 1 && data[editKey[0]]) {
      let index: string = editKey[0];
      editKey.shift();
      return this.find(data[index], editKey);
    }
    return null;
  }

  private getAgValStr(data: any, key: string[]): any  {
    const agency: ICustomerAgency = data.customerAgency;
    return this.find(agency?.distributorAgency?.customerAgency, key) ? this.find(agency?.distributorAgency?.customerAgency, key) : this.find(agency, key);
  }

  private getAgValStrArr(data: any, key: string[]): any[] {
    const agency: ICustomerAgency = data.customerAgency;
    return this.find(agency?.distributorAgency?.customerAgency, key) ? this.find(agency?.distributorAgency?.customerAgency, key) : this.find(agency, key);
  }
}
